import './Input.scss';

import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import Icon from 'ViatoUi/Shared/DataDisplay/Icon';
import OutsideClickHandler from 'ViatoUi/Shared/Utilities/OutsideClickHandler';

const Input = ({ type, onChange, icon, placeholder, required, value, onFocus, customInput, tooltip, className, wrapperClassName }) => {
	const [focused, setFocused] = useState(String(value).length > 0);
	const [newType, setNewType] = useState(type);

	const inputRef = useRef(null);

	useEffect(() => {
		// Workaround for ChromE autofill
		// on autofill a css animation is fired (see css file). With this we can
		// check if the user is using autofill and if so set the focused state to true.
		// ... someone please kill me
		if (customInput === null) {
			inputRef.current.addEventListener('animationstart', e => {
				if (e.animationName === 'autofill') {
					setFocused(true);
				}
			});
		}
	}, [value]);

	return (
		<OutsideClickHandler callback={() => setFocused(String(value).length > 0)} className={`${className} ${wrapperClassName}`}>
			<div
				className={`react__login-input ${className}`}
				data-focused={focused}
				data-has-icon={icon !== null}
				data-has-placeholder={placeholder !== null}
				data-required={required}
			>
				{icon !== null && <Icon className='label-icon' color='extraDarkSmoke' icon={icon} iconWeight='fas' size='xl' />}
				{placeholder !== null && <div className='label'>{placeholder}</div>}

				{customInput !== null ? (
					<>{customInput}</>
				) : (
					<input
						ref={inputRef}
						required={required}
						type={newType}
						value={value}
						onBlur={e => {
							setFocused(e.target.value !== '');
							onChange(e.target.value);
						}}
						onChange={e => {
							setFocused(e.target.value !== '');
							onChange(e.target.value);
						}}
						onFocus={e => {
							onFocus(e);
							setFocused(true);
						}}
					/>
				)}

				{type === 'password' && (
					<Icon
						className='passwordIcon'
						color='extraDarkSmoke'
						icon={newType === 'password' ? 'fa-eye' : 'fa-eye-slash'}
						size='xl'
						onClick={() => {
							if (newType === 'password') {
								setNewType('text');
							} else {
								setNewType('password');
							}
						}}
					/>
				)}

				{tooltip !== null && (
					<Icon className='tooltip' color='warning' icon='fa-info-circle' iconWeight='fal' size='xl' tooltip={tooltip} />
				)}
			</div>
		</OutsideClickHandler>
	);
};

Input.propTypes = {
	type: PropTypes.oneOf(['text', 'password']),
	placeholder: PropTypes.string,
	wrapperClassName: PropTypes.string,
	className: PropTypes.string,
	icon: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	required: PropTypes.bool,
	customInput: PropTypes.node,
	onChange: PropTypes.func,
	onFocus: PropTypes.func,
	tooltip: PropTypes.string
};

Input.defaultProps = {
	type: 'text',
	placeholder: '',
	value: '',
	tooltip: null,
	wrapperClassName: null,
	className: null,
	icon: null,
	customInput: null,
	required: false,
	onChange: () => {},
	onFocus: () => {}
};

export default Input;
